import styled from "styled-components"
import StatusSmall from "../../Ui/Status/StatusSmall"

export const Wrapper = styled.div`
  padding: 0;
`

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: flex-start;
  align-items: stretch;
  padding-bottom: 1rem;
  margin-bottom: 2rem;
`

export const InfoBox = styled.div`
  padding: 1rem 3rem;
  background: ${(p) => p.theme.colors.white};
  flex: 0 1 auto;
  width: fit-content;
  max-width: 100%;
  box-sizing: border-box;
  margin: 0;
  border-radius: 0.6rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 1.1rem;
  color: ${(p) => p.theme.colors.greyDarker};
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
`

export const Label = styled.div`
  line-height: 1.6rem;
  margin-bottom: 0.5rem;
`

export const NoticeWrapper = styled.div`

  div {
    font-size: 1.2rem;
  }

  > div {
    margin: 0;

    > div {
      margin: 1rem 0;
      padding: 0 1rem;
    }

    span {
      margin-right: 2rem;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        display: flex;
        align-self: center;
        height: 1.4rem;
      }
    }

    svg {
      display: none;
    }
  }

`

export const StyledStatus = styled(StatusSmall)``
